// organisms/InvoiceListPanel.tsx
import { Box, List } from '@chakra-ui/react';
import FaceliftText from '@/components/Atoms/FaceliftText';
import { InvoiceListItem } from '@/components/Molecules/InvoiceListItem/InvoiceListItem';
import type { Invoice } from '@/types/invoice';

interface InvoiceListPanelProps {
	invoices: Invoice[];
	activeInvoice: Invoice | null;
	getStatus: (invoice: Invoice) => { label: string; color: string };
	onInvoiceClick: (invoice: Invoice) => void;
}

const InvoiceListPanel: React.FC<InvoiceListPanelProps> = ({
	invoices,
	activeInvoice,
	getStatus,
	onInvoiceClick,
}) => (
	<Box
		borderRight="1px solid"
		borderColor={{ base: 'gray.200', _dark: 'gray.700' }}
		pr={2}
		display="flex"
		flexDirection="column"
		height="100%"
		overflow="hidden"
	>
		<FaceliftText
			fontSize="sm"
			fontWeight="600"
			mb={3}
			px={2}
			color={{ base: 'gray.600', _dark: 'gray.300' }}
			flexShrink={0}
		>
			Select an invoice to view
		</FaceliftText>

		<Box overflowY="auto" flex="1" pr={1}>
			<List.Root gap={2}>
				{invoices.map((invoice: Invoice) => {
					const isActive = activeInvoice?.InvoiceID === invoice.InvoiceID;
					const invoiceStatus = getStatus(invoice);

					return (
						<InvoiceListItem
							key={invoice.InvoiceID}
							invoice={invoice}
							isActive={isActive}
							status={invoiceStatus}
							onClick={() => onInvoiceClick(invoice)}
						/>
					);
				})}
			</List.Root>
		</Box>
	</Box>
);

export default InvoiceListPanel;